<modal class="modal-size-sm">
  @if (title) {
    <ng-container ngProjectAs="modal-header"
      ><modal-header [title]="title">
        <modal-header-actions>
          <header-action-buttons
            [buttons]="headerActionButtons"
          ></header-action-buttons>
        </modal-header-actions> </modal-header
    ></ng-container>
  }
  <modal-content [ngClass]="contentAlign">
    @if (hasIcon) {
      <i class="icon-confirm {{ iconVariant }}"></i>
    }
    @if (contentTitle) {
      <modal-content-title [contentTitle]="contentTitle"></modal-content-title>
    }
    <p>{{ message | translate: messageParams }}</p>
  </modal-content>
  <modal-footer>
    @for (button of confirmButtons; track button) {
      <button
        [ngClass]="button.style"
        [attr.e2e-attr]="button.e2eAttr"
        (click)="buttonClick(button)"
      >
        {{ button.text | translate }}
      </button>
    }
  </modal-footer>
</modal>
